import { SET_MAIN_LOGO } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MAIN_LOGO: {
      return action.payload;
    }
    default:
      return state;
  }
};
